import { z } from 'zod';
import { CoverageRole } from '../enums';
import { requiredEnum } from '../../validation';

// Insurance coverage of the referred patient — whether they are the principal
// plan member or a dependant covered under a principal's plan.
export const ReferralCoverageSchema = z
  .object({
    role: requiredEnum(CoverageRole, 'Coverage role is required'),
    // The principal's assigned member number,
    // e.g. an insurance principal reference id
    subscriberId: z.string().trim().optional(),
  })
  .optional();

export type ReferralCoverage = NonNullable<
  z.infer<typeof ReferralCoverageSchema>
>;
